import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Protocolo } from '@core/models/protocolo';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-resultado-protocolo',
  templateUrl: './resultado-protocolo.component.html',
  styleUrls: ['./resultado-protocolo.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResultadoProtocoloComponent implements OnInit {

  finalizar!: ((value?: Protocolo) => void);
  continuar!: ((value?: Protocolo) => void);
  protocolo!: Protocolo;
  popoverVisible!: boolean;
  tela!: string;
  modalEnvio: any = {
    protocolo: this.protocolo,
    action: ''
  }

  size: NzButtonSize = 'large';

  constructor(private modal: NzModalRef) { }

  ngOnInit(): void {
    // console.log(this.continuar)
  }

  fechar(): void {
    this.modalEnvio.action = "continuar";
    this.modal.close(this.modalEnvio);
  }

  ok(): void {
    this.modalEnvio.action = "finalizar";
    this.modal.close(this.modalEnvio);
  }

  copy(): void {
    if (document.queryCommandSupported('copy')) {
      this.popoverVisible = true;
      navigator.clipboard.writeText(this.protocolo.protocolo).then(function () {

      }, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
  }
}
